// Gerçek takım verileri

const TEAMS = [
  // Türkiye Süper Lig
  {
    id: 'galatasaray',
    name: 'Galatasaray',
    shortName: 'GS',
    league: 'Süper Lig',
    colors: { primary: '#FFC72C', secondary: '#A6001A', away: '#1a1a1a' },
    rating: 85,
    formation: '4-4-2',
    players: [
      { name: 'Muslera', number: 1, position: 'GK', rating: 82 },
      { name: 'Boey', number: 2, position: 'RB', rating: 78 },
      { name: 'Davinson', number: 3, position: 'CB', rating: 83 },
      { name: 'Nelsson', number: 4, position: 'CB', rating: 82 },
      { name: 'Angeliño', number: 5, position: 'LB', rating: 80 },
      { name: 'Torreira', number: 6, position: 'CM', rating: 83 },
      { name: 'Mertens', number: 7, position: 'CAM', rating: 82 },
      { name: 'Ziyech', number: 8, position: 'RM', rating: 81 },
      { name: 'Barış Alper', number: 9, position: 'LM', rating: 77 },
      { name: 'Icardi', number: 10, position: 'ST', rating: 84 },
      { name: 'Osimhen', number: 11, position: 'ST', rating: 87 },
    ]
  },
  {
    id: 'fenerbahce',
    name: 'Fenerbahçe',
    shortName: 'FB',
    league: 'Süper Lig',
    colors: { primary: '#FFED00', secondary: '#002B5C', away: '#ffffff' },
    rating: 84,
    formation: '4-4-2',
    players: [
      { name: 'Livakovic', number: 1, position: 'GK', rating: 82 },
      { name: 'Osayi', number: 2, position: 'RB', rating: 79 },
      { name: 'Djiku', number: 3, position: 'CB', rating: 80 },
      { name: 'Söyüncü', number: 4, position: 'CB', rating: 79 },
      { name: 'Oosterwolde', number: 5, position: 'LB', rating: 78 },
      { name: 'Fred', number: 6, position: 'CM', rating: 81 },
      { name: 'İ. Kahveci', number: 7, position: 'CAM', rating: 80 },
      { name: 'Szymanski', number: 8, position: 'RM', rating: 79 },
      { name: 'Tadic', number: 9, position: 'LM', rating: 81 },
      { name: 'Dzeko', number: 10, position: 'ST', rating: 82 },
      { name: 'En-Nesyri', number: 11, position: 'ST', rating: 83 },
    ]
  },
  {
    id: 'besiktas',
    name: 'Beşiktaş',
    shortName: 'BJK',
    league: 'Süper Lig',
    colors: { primary: '#000000', secondary: '#ffffff', away: '#e0e0e0' },
    rating: 80,
    formation: '4-4-2',
    players: [
      { name: 'Destanoğlu', number: 1, position: 'GK', rating: 80 },
      { name: 'Masuaku', number: 2, position: 'RB', rating: 76 },
      { name: 'Topçu', number: 3, position: 'CB', rating: 77 },
      { name: 'Colley', number: 4, position: 'CB', rating: 78 },
      { name: 'Svensson', number: 5, position: 'LB', rating: 76 },
      { name: 'Gedson', number: 6, position: 'CM', rating: 79 },
      { name: 'Rafa Silva', number: 7, position: 'CAM', rating: 80 },
      { name: 'Güven', number: 8, position: 'RM', rating: 75 },
      { name: 'Muçi', number: 9, position: 'LM', rating: 77 },
      { name: 'Semih', number: 10, position: 'ST', rating: 76 },
      { name: 'Ciro', number: 11, position: 'ST', rating: 80 },
    ]
  },
  {
    id: 'trabzonspor',
    name: 'Trabzonspor',
    shortName: 'TS',
    league: 'Süper Lig',
    colors: { primary: '#7B1126', secondary: '#263B73', away: '#ffffff' },
    rating: 78,
    formation: '4-4-2',
    players: [
      { name: 'Uğurcan', number: 1, position: 'GK', rating: 81 },
      { name: 'Malheiro', number: 2, position: 'RB', rating: 75 },
      { name: 'Bardakçı', number: 3, position: 'CB', rating: 76 },
      { name: 'Savić', number: 4, position: 'CB', rating: 77 },
      { name: 'Eren', number: 5, position: 'LB', rating: 74 },
      { name: 'Lundstram', number: 6, position: 'CM', rating: 76 },
      { name: 'Orsic', number: 7, position: 'CAM', rating: 78 },
      { name: 'Trezeguet', number: 8, position: 'RM', rating: 77 },
      { name: 'Visca', number: 9, position: 'LM', rating: 76 },
      { name: 'Cham', number: 10, position: 'ST', rating: 75 },
      { name: 'Djaniny', number: 11, position: 'ST', rating: 76 },
    ]
  },
  // Avrupa Kulüpleri
  {
    id: 'realmadrid',
    name: 'Real Madrid',
    shortName: 'RMA',
    league: 'La Liga',
    colors: { primary: '#FFFFFF', secondary: '#00529F', away: '#1a1a2e' },
    rating: 92,
    formation: '4-4-2',
    players: [
      { name: 'Courtois', number: 1, position: 'GK', rating: 89 },
      { name: 'Carvajal', number: 2, position: 'RB', rating: 85 },
      { name: 'Rüdiger', number: 3, position: 'CB', rating: 86 },
      { name: 'Alaba', number: 4, position: 'CB', rating: 84 },
      { name: 'Mendy', number: 5, position: 'LB', rating: 83 },
      { name: 'Valverde', number: 6, position: 'CM', rating: 87 },
      { name: 'Bellingham', number: 7, position: 'CAM', rating: 90 },
      { name: 'Modric', number: 8, position: 'RM', rating: 85 },
      { name: 'Vinícius Jr', number: 9, position: 'LM', rating: 92 },
      { name: 'Mbappé', number: 10, position: 'ST', rating: 93 },
      { name: 'Rodrygo', number: 11, position: 'ST', rating: 85 },
    ]
  },
  {
    id: 'barcelona',
    name: 'FC Barcelona',
    shortName: 'BAR',
    league: 'La Liga',
    colors: { primary: '#A50044', secondary: '#004D98', away: '#ededed' },
    rating: 90,
    formation: '4-4-2',
    players: [
      { name: 'ter Stegen', number: 1, position: 'GK', rating: 88 },
      { name: 'Koundé', number: 2, position: 'RB', rating: 85 },
      { name: 'Araújo', number: 3, position: 'CB', rating: 86 },
      { name: 'Cubarsí', number: 4, position: 'CB', rating: 80 },
      { name: 'Baldé', number: 5, position: 'LB', rating: 81 },
      { name: 'Pedri', number: 6, position: 'CM', rating: 87 },
      { name: 'Gavi', number: 7, position: 'CAM', rating: 82 },
      { name: 'De Jong', number: 8, position: 'RM', rating: 84 },
      { name: 'Raphinha', number: 9, position: 'LM', rating: 85 },
      { name: 'Lewandowski', number: 10, position: 'ST', rating: 88 },
      { name: 'Yamal', number: 11, position: 'ST', rating: 84 },
    ]
  },
  {
    id: 'mancity',
    name: 'Manchester City',
    shortName: 'MCI',
    league: 'Premier League',
    colors: { primary: '#6CABDD', secondary: '#1C2C5B', away: '#f0e130' },
    rating: 91,
    formation: '4-4-2',
    players: [
      { name: 'Ederson', number: 1, position: 'GK', rating: 87 },
      { name: 'Walker', number: 2, position: 'RB', rating: 83 },
      { name: 'Dias', number: 3, position: 'CB', rating: 87 },
      { name: 'Stones', number: 4, position: 'CB', rating: 84 },
      { name: 'Gvardiol', number: 5, position: 'LB', rating: 83 },
      { name: 'Rodri', number: 6, position: 'CM', rating: 91 },
      { name: 'De Bruyne', number: 7, position: 'CAM', rating: 91 },
      { name: 'B. Silva', number: 8, position: 'RM', rating: 87 },
      { name: 'Foden', number: 9, position: 'LM', rating: 88 },
      { name: 'Haaland', number: 10, position: 'ST', rating: 92 },
      { name: 'Grealish', number: 11, position: 'ST', rating: 82 },
    ]
  },
  {
    id: 'liverpool',
    name: 'Liverpool',
    shortName: 'LIV',
    league: 'Premier League',
    colors: { primary: '#C8102E', secondary: '#00B2A9', away: '#f6f6f6' },
    rating: 89,
    formation: '4-4-2',
    players: [
      { name: 'Alisson', number: 1, position: 'GK', rating: 88 },
      { name: 'Alexander-Arnold', number: 2, position: 'RB', rating: 86 },
      { name: 'Van Dijk', number: 3, position: 'CB', rating: 89 },
      { name: 'Konaté', number: 4, position: 'CB', rating: 84 },
      { name: 'Robertson', number: 5, position: 'LB', rating: 84 },
      { name: 'Mac Allister', number: 6, position: 'CM', rating: 85 },
      { name: 'Szoboszlai', number: 7, position: 'CAM', rating: 83 },
      { name: 'Gravenberch', number: 8, position: 'RM', rating: 82 },
      { name: 'Díaz', number: 9, position: 'LM', rating: 84 },
      { name: 'Salah', number: 10, position: 'ST', rating: 89 },
      { name: 'Núñez', number: 11, position: 'ST', rating: 83 },
    ]
  },
  {
    id: 'psg',
    name: 'Paris Saint-Germain',
    shortName: 'PSG',
    league: 'Ligue 1',
    colors: { primary: '#004170', secondary: '#DA291C', away: '#ffffff' },
    rating: 88,
    formation: '4-4-2',
    players: [
      { name: 'Donnarumma', number: 1, position: 'GK', rating: 87 },
      { name: 'Hakimi', number: 2, position: 'RB', rating: 85 },
      { name: 'Marquinhos', number: 3, position: 'CB', rating: 85 },
      { name: 'Skriniar', number: 4, position: 'CB', rating: 83 },
      { name: 'N. Mendes', number: 5, position: 'LB', rating: 82 },
      { name: 'Vitinha', number: 6, position: 'CM', rating: 84 },
      { name: 'Zaïre-Emery', number: 7, position: 'CAM', rating: 80 },
      { name: 'Lee Kang-in', number: 8, position: 'RM', rating: 81 },
      { name: 'Barcola', number: 9, position: 'LM', rating: 82 },
      { name: 'Dembélé', number: 10, position: 'ST', rating: 86 },
      { name: 'Gonçalo Ramos', number: 11, position: 'ST', rating: 82 },
    ]
  },
  {
    id: 'bayern',
    name: 'Bayern München',
    shortName: 'BAY',
    league: 'Bundesliga',
    colors: { primary: '#DC052D', secondary: '#0066B2', away: '#ffffff' },
    rating: 89,
    formation: '4-4-2',
    players: [
      { name: 'Neuer', number: 1, position: 'GK', rating: 87 },
      { name: 'Kimmich', number: 2, position: 'RB', rating: 87 },
      { name: 'Upamecano', number: 3, position: 'CB', rating: 83 },
      { name: 'Kim Min-jae', number: 4, position: 'CB', rating: 84 },
      { name: 'Davies', number: 5, position: 'LB', rating: 83 },
      { name: 'Goretzka', number: 6, position: 'CM', rating: 82 },
      { name: 'Müller', number: 7, position: 'CAM', rating: 83 },
      { name: 'Musiala', number: 8, position: 'RM', rating: 86 },
      { name: 'Sané', number: 9, position: 'LM', rating: 84 },
      { name: 'H. Kane', number: 10, position: 'ST', rating: 91 },
      { name: 'Coman', number: 11, position: 'ST', rating: 82 },
    ]
  },
  {
    id: 'juventus',
    name: 'Juventus',
    shortName: 'JUV',
    league: 'Serie A',
    colors: { primary: '#000000', secondary: '#FFFFFF', away: '#FFC72C' },
    rating: 84,
    formation: '4-4-2',
    players: [
      { name: 'Szczęsny', number: 1, position: 'GK', rating: 84 },
      { name: 'Danilo', number: 2, position: 'RB', rating: 78 },
      { name: 'Bremer', number: 3, position: 'CB', rating: 83 },
      { name: 'Gatti', number: 4, position: 'CB', rating: 79 },
      { name: 'Cambiaso', number: 5, position: 'LB', rating: 80 },
      { name: 'Locatelli', number: 6, position: 'CM', rating: 80 },
      { name: 'Rabiot', number: 7, position: 'CAM', rating: 81 },
      { name: 'McKennie', number: 8, position: 'RM', rating: 78 },
      { name: 'Chiesa', number: 9, position: 'LM', rating: 82 },
      { name: 'Vlahovic', number: 10, position: 'ST', rating: 83 },
      { name: 'Yıldız', number: 11, position: 'ST', rating: 78 },
    ]
  },
  {
    id: 'inter',
    name: 'Inter Milan',
    shortName: 'INT',
    league: 'Serie A',
    colors: { primary: '#009CDE', secondary: '#000000', away: '#ffffff' },
    rating: 87,
    formation: '4-4-2',
    players: [
      { name: 'Sommer', number: 1, position: 'GK', rating: 85 },
      { name: 'Dumfries', number: 2, position: 'RB', rating: 80 },
      { name: 'Bastoni', number: 3, position: 'CB', rating: 86 },
      { name: 'Acerbi', number: 4, position: 'CB', rating: 81 },
      { name: 'Dimarco', number: 5, position: 'LB', rating: 83 },
      { name: 'Barella', number: 6, position: 'CM', rating: 86 },
      { name: 'Çalhanoğlu', number: 7, position: 'CAM', rating: 85 },
      { name: 'Mkhitaryan', number: 8, position: 'RM', rating: 81 },
      { name: 'Thuram', number: 9, position: 'LM', rating: 83 },
      { name: 'Lautaro', number: 10, position: 'ST', rating: 88 },
      { name: 'Arnautovic', number: 11, position: 'ST', rating: 78 },
    ]
  },
];

export default TEAMS;
